import { render, staticRenderFns } from "./PrePlanHome.vue?vue&type=template&id=4a1f57c5&scoped=true&"
import script from "./PrePlanHome.vue?vue&type=script&lang=ts&"
export * from "./PrePlanHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1f57c5",
  null
  
)

export default component.exports